import React from 'react'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Container from '@material-ui/core/Container'
import PropTypes from 'prop-types'
import hoc from '@hoc'
import { LanguageSelector } from '@i18n'
import * as utils from '@utils'
import OtpSettingDialog from '@dialogs/otp-setting-dialog'
import { API } from '@const'

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'Login')
        }
    }

    state = {
        account: '',
        password: '',
        otp: '',
        otpVerify: false
    }

    checkOtp = () => {
        return new Promise((resolve, reject) => {
            if (!this.state.account.trim()) {
                resolve()
                return
            }
            utils.apiRequest(
                'get',
                API.CHECK_OTP_ENABLE,
                {
                    account: this.state.account
                },
                (data) => {
                    this.setState({
                        otpVerify: Boolean(data.otp_enable)
                    }, () => resolve())
                },
                (error) => {
                    reject(error)
                },
                true
            )
        })
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.handleSubmit()
        }
    }

    handleValid = () => {
        const { account, password, otp, otpVerify } = this.state
        const validError = [] 
        if (!account.trim()) {
            validError.push(this.t('requiredAccount'))
        }
        if (!password.trim()) {
            validError.push(this.t('requiredPassword'))
        }
        if (otpVerify && !otp.trim()) {
            validError.push(this.t('requiredOtp'))
        }
        return validError
    }

    handleSubmit =  async () => {
        try {
            /** 送出前需檢查帳號是否有開啟otp */
            await this.checkOtp()
            /** 驗證欄位 */
            const validError = this.handleValid()
            if (validError.length) {
                validError.forEach(massage => {
                    utils.addToast(massage, 'error')
                })
                return
            }
            this.login()
        } catch (error) {
            console.log(error)
        }
        
    }

    login = () => {
        const { account, password, otp, otpVerify } = this.state
        const params = {
            account,
            password
        }
        if (otpVerify) {
            params.otp = otp
        }
        this.props.authLogin({...params})
    }

    reset = () =>{
        this.setState({
            account: '',
            password: '',
            otp: ''
        })
    }

    render() {
        const { classes } = this.props

        return (
            <div>
                <Container component="main" maxWidth="xs" className={classes.container}>
                    <CssBaseline />
                    <div className={classes.paper}>
                        <img src="/images/LOGO_s01.png" alt="Logo" className={classes.logo} />
                        <form className={classes.form} noValidate>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label={this.t('account')}
                                name="account"
                                autoComplete="account"
                                autoFocus
                                value={this.state.account}
                                onChange={(event) =>
                                    this.setState({
                                        account: event.target.value,
                                    })
                                }
                                onBlur={async() => await this.checkOtp() }
                                onKeyPress={this.handleKeyPress}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label={this.t('password')}
                                type="password"
                                autoComplete="current-password"
                                value={this.state.password}
                                onChange={(event) =>
                                    this.setState({
                                        password: event.target.value,
                                    })
                                }
                                onKeyPress={this.handleKeyPress}
                            />
                            {this.state.otpVerify && <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="otp"
                                label={this.t('otp')}
                                type="text"
                                value={this.state.otp}
                                onChange={(event) =>
                                    this.setState({
                                        otp: event.target.value,
                                    })
                                }
                                onKeyPress={this.handleKeyPress}
                            />}
                            <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={this.handleSubmit}>
                                {this.t('signIn')}
                            </Button>
                        </form>
                    </div>
                </Container>
                <div className={classes.floating}>
                    <LanguageSelector icon={{ style: { color: 'initial' } }} />
                </div>
                {this.props.auth.otpSettingShow && <OtpSettingDialog compDialogArgs={{account: this.state.account, password: this.state.password}} loginReset={this.reset} />}
            </div>
            
        )
    }
}

const styles = (theme) => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    container: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -70%);',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    floating: {
        position: 'fixed',
        right: '20px',
        top: '20px',
    },
    logo: {
        margin: 'auto',
    },
})

Login.propTypes = {
    classes: PropTypes.object,
    init: PropTypes.func,
    authLogin: PropTypes.func,
    auth: PropTypes.object,
}

export default hoc(styles)(Login)
